import * as ko from 'knockout'
import '../../../../AppUtils/Framework/CustomBindings/StickyBinding'
import { BettingInformation } from '../../../Model/BettingInformation'
import ObservableRacePage from '../../../Model/Observables/ObservableRacePage'
import { StartersPageViewModel } from './StartersPageViewModel'
import template from './starters.tpl.html'

if (!ko.components.isRegistered('starters-page')) {
  ko.components.register('starters-page', {
    viewModel: {
      createViewModel: (params: {
        raceInformation: ObservableRacePage
        bettingInformation: BettingInformation
      }) => {
        const viewModel = new StartersPageViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
